export const FEATURE_DEMO_CHANNEL_URL = 'T025A2121/B0A4Q7AEYQ2/s0bGPbidWQfbYn3BZrAGiJ43';
export const PURCHASED_CHANNEL_URL = 'T025A2121/B0A5JBK107J/zmlz5ddVZILqL8rfYbBVr8u1';